module.exports = __webpack_public_path__ + "static/media/searching.2f2ad951.gif";